import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import HomePage from './components/HomePage';
import LandingPage from './components/LandingPage';
import RegistrationPage from './components/RegistrationPage';
import ChinaPage from './components/ChinaPage';
import CnPage from './components/CnPage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import CompliancePolicyPage from './components/CompliancePolicyPage';
import TrainingGatePage from './pages/training/TrainingGatePage';
import TrainingWeekPage from './pages/training/TrainingWeekPage';
import TrainingCompletePage from './pages/training/TrainingCompletePage';
import TrainingAdminPage from './pages/training/TrainingAdminPage';
import TgpayKycPage from './components/TgpayKycPage';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Homepage → FinaConnect landing */}
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/landing" element={<LandingPage />} />

          {/* Registration page */}
          <Route path="/register" element={<RegistrationPage />} />

          {/* Temporary password-protected TGPay IDV pages */}
          <Route path="/tgpay/kyc/:pageId" element={<TgpayKycPage />} />

          {/* China pages with iframe */}
          <Route path="/portal/china" element={<ChinaPage />} />
          <Route path="/cn" element={<CnPage />} />

          {/* Policy pages */}
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/compliance-policy" element={<CompliancePolicyPage />} />

          {/* AML Training */}
          <Route path="/training" element={<TrainingGatePage />} />
          <Route path="/training/session/:token" element={<TrainingWeekPage />} />
          <Route path="/training/complete" element={<TrainingCompletePage />} />
          <Route path="/training/admin" element={<TrainingAdminPage />} />

          {/* Legacy redirects for brand-specific policy pages */}
          <Route path="/:brand/terms" element={<TermsPage />} />
          <Route path="/:brand/privacy" element={<PrivacyPage />} />
          <Route path="/:brand/compliance-policy" element={<CompliancePolicyPage />} />

          {/* Brand-specific landing pages */}
          <Route path="/:brand" element={<LandingPage />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
